export const DICT = {
  en: {
    nav: { apply: "Apply Now" },
    hero: {
      eyebrow: "Financial Advisory & Loan Solutions",
      l1: "Secure Financing",
      l2: "Tailored To",
      l3: "Your Ambition",
      sub: "Malaysia's trusted financing advisory since 2015 offering fast approvals from RM1,000 to RM500,000.",
      cta: "Begin Loan Application",
      secondary: "Explore 1.5% Rates",
      range: "Approval Range",
      monthly: "Monthly Rate",
      annual: "Annual Range",
    },
    marquee: ["TRUSTED SINCE 2015", "PERSONAL LOAN FROM 1.5%", "BUSINESS EXPANSION FINANCING", "DIRECT WHATSAPP SUBMISSION", "RM1,000 TO RM500,000"],
    types: {
      eyebrow: "Tailored Products",
      title: "Personal & Business Loan Solutions",
      personal: {
        name: "Personal Loan",
        badge: "1.5% Monthly",
        desc: "Designed for household stability, debt consolidation, renovation, or urgent medical commitments.",
        bullets: ["RM1,000 to RM100,000", "Flexible tenure 6 to 60 months", "Instant WhatsApp verification"],
        cta: "Apply For Personal Loan",
      },
      business: {
        name: "Business Loan",
        badge: "8% – 18% Annual",
        desc: "Empowering Malaysian SMEs, retail owners, and contractors with rolling capital and inventory financing.",
        bullets: ["RM10,000 to RM500,000", "High approval ceiling for registered entities", "Dedicated business consultant desk"],
        cta: "Apply For Business Loan",
      },
    },
    band: {
      eyebrow: "Operational Integrity",
      title: "9 Years of Transparent Lending in Malaysia",
      contact: "Admin Helpline: 011-3335-7865 • icreditcompany816@gmail.com",
    },
    form: {
      eyebrow: "Online Submission",
      title: "Loan Application Document",
      sub: "Complete all sections. Upon submission, details are routed straight to our official WhatsApp admin.",
      s1: "1. Financing Requirements",
      s2: "2. Applicant Details",
      s3: "3. Family & Background Information",
      labels: {
        loan_type: "Loan Type",
        loan_amount: "Loan Amount (RM 1,000 - RM 500,000)",
        purpose: "Apply Loan For What (Purpose)",
        full_name: "Full Name",
        age: "Age",
        phone: "Phone Number (WhatsApp)",
        occupation: "Job Occupation",
        salary: "Monthly Salary (RM)",
        area: "Area Location (State/City)",
        residential_status: "Residential Status",
        father_working: "Father Working Status",
        mother_working: "Mother Working Status",
        marital_status: "Marital Status (Marry?)",
        spouse_occupation: "Spouse Occupation (If Married)",
        children: "How Many Children?",
        siblings: "How Many Brother and Sister?",
      },
      placeholders: {
        loan_amount: "e.g. RM 50,000",
        purpose: "e.g. Business inventory expansion / Debt settlement",
        full_name: "As per IC / Passport",
        age: "e.g. 32",
        phone: "01X-XXXXXXX",
        occupation: "e.g. Executive / Business Owner",
        salary: "e.g. RM 4,500",
        area: "e.g. Kuala Lumpur / Johor",
        spouse_occupation: "Spouse occupation or N/A",
      },
      options: {
        personal: "Personal Loan (1.5% per month)",
        business: "Business Loan (8% - 18% per year)",
        renting: "Renting a home",
        mortgage: "Paying monthly mortgage",
        owned: "Fully owned",
        working: "Working",
        father_not: "Retired / Not Working",
        mother_not: "Housewife / Retired",
        single: "Single",
        married: "Married",
        divorced: "Divorced",
      },
      submit: "Submit Application & Connect to WhatsApp (011-3335-7865)",
      note: "Instant acknowledgement screen will generate before forwarding full payload to official WhatsApp Admin.",
      submitting: "Submitting...",
      errors: {
        required: "Please complete all required fields.",
        amount: "Loan amount must be between RM1,000 and RM500,000.",
        phone: "Please enter a valid phone number.",
        submit: "Submission failed. Please try again or contact us on WhatsApp.",
      },
    },
    thank: {
      title: "Application Received!",
      titleZh: "申请已收到",
      sub: "Thank you. Your loan application has been received.",
      ref: "Reference No.",
      redirect: "Redirecting you to WhatsApp to send your full application",
      seconds: "s",
      press_send: "One last step: tap SEND in WhatsApp to deliver your application to us.",
      cta: "Open WhatsApp Now",
    },
    reviews: {
      eyebrow: "Client Verified Feedback",
      title: "Client Experiences",
      note: "9 Years of Financial Advisory",
      p1: "Fast and transparent process. I submitted the form at night and received a call the next morning. The 1.5% monthly rate was exactly as stated, with no hidden charges.",
      p2: "iCredit helped my hardware shop restock before the festive season. The business loan approval was quick, and the consultant explained every detail clearly over WhatsApp.",
      l1: "M***d R***n — Personal Loan, Kuala Lumpur",
      l2: "C***g L** M** — Business Loan, Johor",
    },
    footer: {
      tagline: "Trusted financial loan advisory in Malaysia. Supporting individuals and business growth since 2015.",
      contacts: "Official Contacts",
      phone: "Phone / WhatsApp:",
      email: "Email:",
      hours: "Operating Hours: Mon – Sat, 9:00 AM – 6:00 PM",
      products: "Loan Products",
      pl: "Personal Loan (1.5% per month)",
      bl: "Business Loan (8% – 18% per year)",
      ceiling: "Disbursement ceiling: RM500,000",
      rights: "© 2025 iCredit Financial Advisory. All rights reserved.",
      wa: "Direct WhatsApp integration enabled.",
    },
  },
  zh: {
    nav: { apply: "立即申请" },
    hero: {
      eyebrow: "金融顾问与贷款方案",
      l1: "安心融资",
      l2: "量身定制",
      l3: "成就您的雄心",
      sub: "自2015年起，马来西亚值得信赖的融资顾问，提供 RM1,000 至 RM500,000 的快速审批贷款。",
      cta: "开始贷款申请",
      secondary: "了解 1.5% 利率",
      range: "贷款额度范围",
      monthly: "月利率",
      annual: "年利率范围",
    },
    marquee: ["TRUSTED SINCE 2015", "个人贷款 1.5% 起", "商业扩展融资", "WHATSAPP 直接提交", "RM1,000 至 RM500,000"],
    types: {
      eyebrow: "专属产品",
      title: "个人与商业贷款方案",
      personal: {
        name: "个人贷款",
        badge: "1.5% 月利率",
        desc: "专为家庭稳定、债务整合、房屋装修或紧急医疗需求而设计。",
        bullets: ["RM1,000 至 RM100,000", "灵活期限 6 至 60 个月", "WhatsApp 即时确认"],
        cta: "申请个人贷款",
      },
      business: {
        name: "商业贷款",
        badge: "8% – 18% 年利率",
        desc: "为马来西亚中小企业、零售商家与承包商提供周转资金与库存融资。",
        bullets: ["RM10,000 至 RM500,000", "注册公司享更高批准额度", "专属商业顾问服务"],
        cta: "申请商业贷款",
      },
    },
    band: {
      eyebrow: "诚信经营",
      title: "九年马来西亚透明贷款服务",
      contact: "行政热线：011-3335-7865 • icreditcompany816@gmail.com",
    },
    form: {
      eyebrow: "在线提交",
      title: "Loan Application Document 贷款申请表",
      sub: "请完整填写所有部分。提交后，资料将直接发送至我们的官方 WhatsApp 管理员。",
      s1: "1. 贷款需求",
      s2: "2. 申请人资料",
      s3: "3. 家庭与背景资料",
      labels: {
        loan_type: "贷款类型",
        loan_amount: "贷款金额 (RM 1,000 - RM 500,000)",
        purpose: "贷款用途",
        full_name: "全名",
        age: "年龄",
        phone: "电话号码 (WhatsApp)",
        occupation: "职业",
        salary: "月薪 (RM)",
        area: "居住地区（州/城市）",
        residential_status: "居住状况",
        father_working: "父亲工作状况",
        mother_working: "母亲工作状况",
        marital_status: "婚姻状况",
        spouse_occupation: "配偶职业（如已婚）",
        children: "孩子人数",
        siblings: "兄弟姐妹人数",
      },
      placeholders: {
        loan_amount: "例如 RM 50,000",
        purpose: "例如：商业库存扩张 / 债务清算",
        full_name: "依身份证 / 护照",
        age: "例如 32",
        phone: "01X-XXXXXXX",
        occupation: "例如：执行人员 / 自雇人士",
        salary: "例如 RM 4,500",
        area: "例如：吉隆坡 / 柔佛",
        spouse_occupation: "配偶职业或 N/A",
      },
      options: {
        personal: "个人贷款（1.5% / 月）",
        business: "商业贷款（8% - 18% / 年）",
        renting: "租房",
        mortgage: "每月供房",
        owned: "已拥有房产",
        working: "在职",
        father_not: "退休 / 无业",
        mother_not: "家庭主妇 / 退休",
        single: "单身",
        married: "已婚",
        divorced: "离婚",
      },
      submit: "提交申请并连接 WhatsApp (011-3335-7865)",
      note: "提交后将显示确认画面，随后自动跳转至官方 WhatsApp 管理员。",
      submitting: "提交中…",
      errors: {
        required: "请完整填写所有必填栏位。",
        amount: "贷款金额必须介于 RM1,000 至 RM500,000 之间。",
        phone: "请输入有效的电话号码。",
        submit: "提交失败，请重试或直接通过 WhatsApp 联系我们。",
      },
    },
    thank: {
      title: "Application Received!",
      titleZh: "申请已收到",
      sub: "谢谢您，我们已收到您的贷款申请。",
      ref: "申请编号",
      redirect: "即将跳转到 WhatsApp 发送您的完整申请资料",
      seconds: "秒",
      press_send: "最后一步：请在 WhatsApp 页面按「发送」，把资料发给我们。",
      cta: "立即打开 WhatsApp",
    },
    reviews: {
      eyebrow: "客户真实反馈",
      title: "客户体验",
      note: "9 年金融顾问经验",
      p1: "流程快速透明。我晚上提交表格，隔天早上就接到电话。1.5% 月利率与说明完全一致，没有任何隐藏费用。",
      p2: "iCredit 帮我的五金店在节庆前顺利进货。商业贷款审批很快，顾问在 WhatsApp 上把每一项都解释得清清楚楚。",
      l1: "M***d R***n — 个人贷款，吉隆坡",
      l2: "C***g L** M** — 商业贷款，柔佛",
    },
    footer: {
      tagline: "马来西亚值得信赖的金融贷款顾问，自2015年起支持个人与企业成长。",
      contacts: "官方联系方式",
      phone: "电话 / WhatsApp：",
      email: "电子邮件：",
      hours: "营业时间：周一至周六 9:00 AM – 6:00 PM",
      products: "贷款产品",
      pl: "个人贷款（1.5% / 月）",
      bl: "商业贷款（8% – 18% / 年）",
      ceiling: "最高放款额：RM500,000",
      rights: "© 2025 iCredit Financial Advisory. 版权所有。",
      wa: "已启用 WhatsApp 直接联系。",
    },
  },
};

// Canonical English values submitted to the backend, mapped to display labels per language.
export const OPTION_VALUES = {
  loan_type: ["Personal Loan (1.5% per month)", "Business Loan (8% - 18% per year)"],
  residential_status: ["Renting a home", "Paying monthly mortgage", "Fully owned"],
  father_working: ["Working", "Retired / Not Working"],
  mother_working: ["Working", "Housewife / Retired"],
  marital_status: ["Single", "Married", "Divorced"],
};

export const OPTION_LABEL_KEYS = {
  loan_type: ["personal", "business"],
  residential_status: ["renting", "mortgage", "owned"],
  father_working: ["working", "father_not"],
  mother_working: ["working", "mother_not"],
  marital_status: ["single", "married", "divorced"],
};
